import { BYTES_IN_GB, BYTES_IN_KB, BYTES_IN_MB } from 'constants/fileSize';

export const bytesToMb = (bytes: number): number => bytes / BYTES_IN_MB;

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  if (bytes < BYTES_IN_KB) {
    return `${bytes} Bytes`;
  }

  if (bytes < BYTES_IN_MB) {
    return `${(bytes / BYTES_IN_KB).toFixed(1)} KB`;
  }

  if (bytes < BYTES_IN_GB) {
    return `${(bytes / BYTES_IN_MB).toFixed(1)} MB`;
  }

  return `${(bytes / BYTES_IN_GB).toFixed(1)} GB`;
};
